export class SelectedBGLocalStorage {
  static readonly SELECTED_BG_NAME = "selectedBG";
}
